<template>
    <div class="modi_group">
        <div class="modi_head">
            <div class="modi_group_info">
                <h3 :class="{'modi_group_invalid': !isValidGroup()}"> {{ group.groupname }} </h3>
                <h5 :class="{'modi_group_invalid': !isValidGroup()}" v-if="group.downlimit > -1">Выберите не менее {{group.downlimit}}</h5>
            </div>
            <span :class="{'modi_group_invalid': !isValidGroup()}" class="spin_value">{{groupCnt}}{{normalizeLimit}}</span>
        </div>
        <ul class="modi_item_list">
            <Modifier v-for="item in group.items" :key="item.ident" :item="item" :changesprice="group.changesprice" :limit="upperLimit" :usedcount="groupCnt" @modi="onModiSelect"/>
        </ul>
        <hr/>
    </div>
</template>

<script>

import Modifier from './Modifier'
export default {
    data(){
        return {
            groupCnt: 0
        }
    },
    props:['group'],
    computed:{
        upperLimit(){
            return (this.group.uplimit > -1) ? this.group.uplimit : undefined
        },
        normalizeLimit(){
            return (this.group.uplimit > -1) ? '/'+this.group.uplimit : ''
        }
    },
    methods:{
        onModiSelect(modi){
            this.groupCnt += modi.dt_cnt
            this.$emit('validity', {id:this.group.groupid, value: !!this.isValidGroup()})
            this.$emit('modi', modi)
        },
        isValidGroup(){
            return (this.groupCnt >= this.group.downlimit) && (this.groupCnt <= (this.group.uplimit > -1) ? this.group.uplimit : 9999)
        }
    },
    mounted(){
        this.$emit('validity', {id:this.group.groupid, value: !!this.isValidGroup()})
    },
    components:{
        Modifier
    }
    
}
</script>